// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  identityHex: __t.string(),
  kdf: __t.string(),
  kdfN: __t.u32(),
  kdfR: __t.u32(),
  kdfP: __t.u32(),
  salt: __t.string(),
  hash: __t.string(),
  recoveryHashes: __t.string(),
  bumpEpoch: __t.bool(),
};
